import React, { FC } from 'react'
import { useParams, Route, Switch, useRouteMatch } from 'react-router'
import { Catalogue } from '../containers/Catalogue'
import { Cart } from '../containers/Cart'
import { Product } from '../containers/Product'
import { ThemeProvider, ITheme } from '@chakra-ui/core'
import defaultTheme from '../containers/Catalogue/theme'
import { useQuery } from '@apollo/client'
import { getStorefrontConfig, searchProductsByNameQuery } from '../queries/index'
import {
    getStoreFrontVariables,
    getStoreFront,
    getStoreFront_orderConfig as IOrderConfig,
} from '@engyalo/storefront-types/lib/graphql/storefront'
import { useRecoilState, useSetRecoilState } from 'recoil'
import { configState, orderConfigState } from '../recoil/atoms'
import { IConfig } from '../recoil/types'
import { Helmet } from 'react-helmet'
import { parseTheme } from '../lib/utilities'
import { IProductsPricedPerCollectionVariables, IProductsPricedPerCollection } from '@engyalo/storefront-types/lib/graphql/product'

export const CatalogueRoute: FC = () => {
    const { path } = useRouteMatch()
    const { customer, order } = useParams()
    const [config, setConfig] = useRecoilState<IConfig>(configState)
    const setOrderConfig = useSetRecoilState<IOrderConfig>(orderConfigState)
    const [theme, setTheme] = React.useState<ITheme>(defaultTheme)

    const { loading: loadingConfig } = useQuery<getStoreFront, getStoreFrontVariables>(getStorefrontConfig, {
        variables: {
            name: customer,
            configId: order,
        },
        skip: !customer,
        onCompleted: (data) => {
            if (data.storefront && data.storefront.config) {
                const currentConfig = data.storefront.config[0] ?? {}
                if (data.orderConfig) setOrderConfig(data.orderConfig)
                setConfig({
                    logo: currentConfig.logo || config.logo,
                    favicon: currentConfig.favicon || config.favicon,
                    currency: data.storefront.currency || config.currency,
                    currencyPrefix: data.storefront.currencyPrefix || config.currencyPrefix,
                    storefrontId: data.storefront.id || '',
                    enabledOrderNote: data.storefront.enabledOrderNote || config.enabledOrderNote,
                })
                data.storefront.config.forEach((config) => {
                    const { type } = config
                    if (type === 'theme') {
                        setTheme(parseTheme(config, defaultTheme))
                    }
                })
            }
        },
    })

    const { loading: loadingProducts, data } = useQuery<IProductsPricedPerCollection, IProductsPricedPerCollectionVariables>(
        searchProductsByNameQuery,
        {
            variables: {
                name: customer,
                configId: order,
                product: '',
            },
            skip: !customer,
            returnPartialData: true,
            fetchPolicy: 'no-cache',
        }
    )

    const loading = loadingConfig || loadingProducts

    // console.log('THEME', theme)
    // console.log('PRODUCTS', data)

    return (
        <ThemeProvider theme={theme}>
            {config.favicon && (
                <Helmet>
                    <meta charSet="utf-8" />
                    <link rel="icon" href={config.favicon} />
                </Helmet>
            )}

            <Switch>
                <Route exact path={path}>
                    <Catalogue loading={loading} products={data?.productsPricedPerCollection || []} />
                </Route>
                <Route path={`${path}/cart`}>
                    <Cart />
                </Route>
                <Route path={`${path}/product`}>
                    <Product />
                </Route>
            </Switch>
        </ThemeProvider>
    )
}
